export default __webpack_public_path__ + "static/media/Chain.358198c9.jpeg";